import React from "react";

export const Textarea = ({ className = "", ...props }) => {
  return (
    <textarea
      className={`w-full border rounded-md px-3 py-2 text-sm ${className}`}
      {...props}
    />
  );
};